export default __webpack_public_path__ + "static/media/textLogo_v1.2519c03c.svg";